exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fade-top-enter-active[data-v-de89ff8c],.fade-top-leave-active[data-v-de89ff8c]{-webkit-transition:opacity .2s ease,-webkit-transform .2s ease;transition:opacity .2s ease,-webkit-transform .2s ease;transition:transform .2s ease,opacity .2s ease;transition:transform .2s ease,opacity .2s ease,-webkit-transform .2s ease}.fade-top-enter[data-v-de89ff8c],.fade-top-leave-to[data-v-de89ff8c]{-webkit-transform:translateY(-5px);transform:translateY(-5px);opacity:0}", ""]);

// exports
